import { InjectionToken } from '@angular/core';

import { AddressEditTabPlugin } from '../interfaces';

export const ADDRESS_EDIT_TAB_PLUGIN = new InjectionToken<AddressEditTabPlugin[]>('AddressEditTabPlugin');
